import { render } from "./AttributeValuePicker.vue?vue&type=template&id=257946f1"
import script from "./AttributeValuePicker.vue?vue&type=script&lang=js"
export * from "./AttributeValuePicker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__